import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersApiService } from 'src/app/core/services/api/users-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { NgSelectProps } from '../../models/ng-select-props';
import { User } from '../../models/users/user';
import { LawyersApiService } from './../../../core/services/api/lawyers-api.service';
import { Lawyer, LawyerLite } from 'src/app/shared/models/lawyers/lawyer';
import { LawyerCreateEditComponent } from 'src/app/shared/settings/lawyer-create-edit/lawyer-create-edit.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-create-edit',
  templateUrl: './user-create-edit.component.html',
  styleUrls: ['./user-create-edit.component.scss']
})
export class UserCreateEditComponent implements OnInit {

  public user: User;
  public cities = cities;
  public countries = countries;
  public userEmail = null;
  userLawyer: LawyerLite = null;

  @ViewChild('userModal') userModal;
  @Output() submit: EventEmitter<User> = new EventEmitter<User>();

  modalRef: NgbModalRef;

  @ViewChild('lawyerModal') lawyerModal: LawyerCreateEditComponent;
  lawyerNgSelect;

  constructor(
    private modalService: NgbModal,
    private api: UsersApiService,
    private spinner: NgxSpinnerService,
    private lawyerApi: LawyersApiService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.lawyerNgSelect = new NgSelectProps(this.lawyerApi.getLawyersWithoutUsers);
  }

  // handle the popup
  open(user: User) {
    this.user = Object.assign(new User(), user);
    this.userLawyer = this.user.lawyer;
    this.userEmail = this.user.email;
    this.modalRef = this.modalService.open(this.userModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit(f: FormControl) {
    if (this.user.id) {
      this.spinner.show();
      this.api.updateUser(this.user).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createUser(this.user).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

  addLawyerFn = (lawyer) => {
    document.querySelector('.modal').classList.remove('d-block');
    this.addItemFn(new Lawyer(), lawyer, this.lawyerModal, 'name', 'nameAr');
  }

  addItemFn = (item: any, value: string, itemModal: any, prop: string, propAr: string = null) => {
    if (/^[\u0600-\u06FF]{1,}/.test(value) && propAr) {
      item[propAr] = value;
    } else {
      item[prop] = value;
    }
    itemModal.open(item);
  }

  lawyerSubmit(lawyer: Lawyer) {
    this.user.lawyer = Object.assign(new LawyerLite(), lawyer);
    this.user.lawyer.level = lawyer.level.name;
    this.changeLawyer(lawyer);
    this.lawyerModal.close();
    this.toastr.success('Lawyer added', 'Success!');
  }

  oncloseLawyerModal() {
    document.querySelector('.modal').classList.add('d-block');
  }

  changeLawyer(lawyer: Lawyer) {
    this.user.lawyerId = lawyer.id;
    this.user.name = lawyer.getName;
    this.user.email = lawyer.email;
    this.userEmail = lawyer.email;
    this.user.phone = lawyer.phone;
  }

  searchFn() {
    return true;
  }

}

